 
export const api_guest = {
  send_valid_code: "/user/send_valid_code",
  email_login: "/user/email_login",
  token_login: "/user/token_login",
  forgot_pwd: "/user/forgot_pwd",
};
